import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-top: 60px;\n  overflow-y: auto;\n  position: relative;\n  width: 100%;\n\n  @media screen and (max-width: ", "px) {\n    padding-bottom: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { styled } from '@acorns/web-components';
import { style } from '../../../../theme';
import FeatureToggle from './FeatureToggle';
import EnvToggle from './EnvToggle';
var StyledFeatureList = styled.div(_templateObject(), style(function (theme) {
  return theme.breakpoints.sm;
}));
var StyledFeatureToggleWrapper = styled.div(_templateObject2());

var FeatureToggleList = function FeatureToggleList(_ref) {
  var featureNames = _ref.featureNames,
      handleEnvToggle = _ref.handleEnvToggle,
      optimizelyEnv = _ref.optimizelyEnv;
  return /*#__PURE__*/React.createElement(StyledFeatureList, null, /*#__PURE__*/React.createElement(EnvToggle, {
    onToggle: handleEnvToggle,
    optimizelyEnv: optimizelyEnv
  }), /*#__PURE__*/React.createElement(StyledFeatureToggleWrapper, null, featureNames.map(function (featureName) {
    return /*#__PURE__*/React.createElement(FeatureToggle, {
      featureName: featureName,
      key: featureName
    });
  })));
};

export default FeatureToggleList;